import { t } from '@lingui/core/macro';
import { getProjectStatusLabels } from 'app/domains/projects';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
export const projectStatusFilterLabel = () => t({ message: 'Status', comment: 'Insights filter: Project status' });
export const ProjectStatusFilter = withFilterErrorBoundary(() => {
    const labels = getProjectStatusLabels();
    const items = Object.entries(labels).map(([id, title]) => ({ id, title }));
    return <SearchStringFilter name="metadataProjectStatus" items={items} label={projectStatusFilterLabel()}/>;
});
